import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";


// Icones 
// https://themesbrand.com/skote-mvc/layouts/icons-boxicons.html?

interface AudioRecorderProps {
  onSend: (base64: string) => void;
  onCancel: () => void;
}

const AudioRecorder = ({ onSend, onCancel }: AudioRecorderProps) => {
  const [permission, setPermission] = useState(false);
  const [recording, setRecording] = useState(false);
  const [audioURL, setAudioURL] = useState<string | null>(null);
  const [audioBase64, setAudioBase64] = useState<string | null>(null);

  const [recordTime, setRecordTime] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const streamRef = useRef<MediaStream | null>(null);
  const chunksRef = useRef<Blob[]>([]);

  /* ---------------- MIME ---------------- */
  const getSupportedMimeType = () => {
    const types = [
      "audio/webm;codecs=opus",
      "audio/webm",
      "audio/ogg;codecs=opus",
      "audio/ogg",
    ];
    return types.find((t) => MediaRecorder.isTypeSupported(t)) || "";
  };

  /* ---------------- PERMISSÃO ---------------- */
  const getMicrophonePermission = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      setPermission(true);
      startRecording();
    } catch {
      alert("Permissão para microfone negada.");
    }
  };

  /* ---------------- TIMER ---------------- */
  const startTimer = () => {
    setRecordTime(0);
    timerRef.current = setInterval(() => {
      setRecordTime((t) => t + 1);
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const formatTime = (s: number) => {
    const m = String(Math.floor(s / 60)).padStart(2, "0");
    const sec = String(s % 60).padStart(2, "0");
    return `${m}:${sec}`;
  };

  /* ---------------- START ---------------- */
  const startRecording = () => {
    if (!streamRef.current) return;

    const mimeType = getSupportedMimeType();
    if (!mimeType) {
      alert("Formato de áudio não suportado neste navegador.");
      return;
    }

    chunksRef.current = [];
    setAudioURL(null);
    setAudioBase64(null);

    const recorder = new MediaRecorder(streamRef.current, { mimeType });
    mediaRecorderRef.current = recorder;

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) chunksRef.current.push(e.data);
    };

    recorder.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: mimeType });
      const url = URL.createObjectURL(blob);
      setAudioURL(url);

      const reader = new FileReader();
      reader.onloadend = () => {
        setAudioBase64(reader.result as string);
      };
      reader.readAsDataURL(blob);
    };

    recorder.start();
    setRecording(true);
    startTimer();
  };

  /* ---------------- STOP ---------------- */
  const stopRecording = () => {
    stopTimer();
    mediaRecorderRef.current?.stop();
    setRecording(false);
  };

  /* ---------------- CANCEL ---------------- */
  const handleCancel = () => {
    stopTimer();
    setAudioURL(null);
    setAudioBase64(null);
    chunksRef.current = [];
    onCancel();
  };

  /* ---------------- SEND ---------------- */
  const handleSend = () => {
    if (audioBase64) onSend(audioBase64);
  };

  /* ---------------- CLEANUP ---------------- */
  useEffect(() => {
    return () => {
      streamRef.current?.getTracks().forEach((t) => t.stop());
    };
  }, []);

  return (
    <div className="audio-recorder-wrapper">
      <h5>🎙️ Gravador de Áudio</h5>

      {!permission && (
        <Button
          color="none"
          type="button"
          className="btn btn-link text-decoration-none waves-effect "
          id="audio-btn"
          onClick={getMicrophonePermission}
        >
          <i className="bx bx-microphone align-middle"></i> Permitir Microfone
        </Button>
      )}

      {permission && !recording && !audioURL && (
        <button className="primary-btn" onClick={startRecording}>
          ⏺️ Gravar
        </button>
      )}

      {/* 🔴 GRAVANDO */}
      {recording && (
        // <div className="recording-box">
        //   <span className="recording-time"><i className="bx bx-stopwatch" style={{ fontSize: 22 }}></i> {formatTime(recordTime)}</span>

        //   <div className="loader-bars">
        //     <div />
        //     <div />
        //     <div />
        //     <div />
        //     <div />
        //   </div>

        //   <Button
        //     type="button"
        //     color="danger"
        //     className="stop-btn d-flex align-items-center gap-2"
        //     onClick={stopRecording}
        //   >
        //     <i className="bx bx-stop" style={{ fontSize: 22 }}></i>
        //     <span>Parar</span>
        //   </Button>
        // </div>

        <div className="recording-box">
          <span className="recording-time">
            <i className="bx bx-stopwatch"></i>
            {formatTime(recordTime)}
          </span>

          <div className="loader-bars">
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>

          <Button
            type="button"
            color="light"
            className="stop-btn recording-stop d-flex align-items-center gap-2"
            onClick={stopRecording}
          >
            <i className="bx bx-stop"></i>
            <span>Parar</span>
          </Button>
        </div>

      )}

      {/* 🎧 PREVIEW MODERNO */}
      {audioURL && !recording && (
        <div className="audio-preview-modern">
          <audio src={audioURL} controls />

          {/* <div className="preview-actions"> */}
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button className="icon-btn" onClick={handleCancel} title="Cancelar">
              <i className="bx bx-stop-circle" style={{ fontSize: 22 }}></i>
            </button>

            <button className="icon-btn" onClick={startRecording} title="Regravar">
              <i className="bx bx-reset" style={{ fontSize: 22 }}></i>
            </button>

            <button className="icon-btn" onClick={handleSend} title="Enviar">
              <i className="bx bxs-send align-middle" style={{ fontSize: 22 }}></i>
            </button>

          </div>
        </div>
      )}

      {/* 🎨 CSS */}
      <style>{`
        .audio-recorder-wrapper {
          max-width: 420px;
          margin: auto;
          padding: 16px;
          border-radius: 14px;
          background: #f7f7f7;
        }

        h5 {
          text-align: center;
          margin-bottom: 14px;
        }

        .primary2-btn {
          background: #1db954;
          cursor: pointer;
        }        

        .primary-btn {
          width: 100%;
          padding: 12px;
          border-radius: 10px;
          border: none;
          background: #1db954;
          font-weight: 600;
          cursor: pointer;
        }

.recording-box {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f5f7fa;
  padding: 8px 12px;
  border-radius: 14px;
}

.recording-time {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #4a5568;
  font-weight: 500;
}

.recording-time i {
  font-size: 18px;
  color: #6b7280;
}

/* Barras */
.loader-bars div {
  background: #94a3b8; /* cinza azulado */
}

/* Botão parar */
.recording-stop {
  padding: 6px 12px;
  border-radius: 20px;

  font-weight: 500;
  // background: #6b7280; /* slate-500 */
  // color: #fff;

// background: #9ca3af; /* gray-400 */
// color: #111827;  

background: #64748b; /* slate-500 puxando pro azul */
color: #fff;
}

.recording-stop i {
  font-size: 18px;
  color: #374151;
}


        .loader-bars div:nth-child(2){animation-delay:.1s}
        .loader-bars div:nth-child(3){animation-delay:.2s}
        .loader-bars div:nth-child(4){animation-delay:.3s}
        .loader-bars div:nth-child(5){animation-delay:.4s}

        @keyframes pulse {
          0%,100%{transform:scaleY(.3)}
          50%{transform:scaleY(1)}
        }


.audio-preview-modern {
  background: rgba(245, 246, 248, 0.95);
  padding: 14px;
  border-radius: 16px;
  color: #222;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.audio-preview-modern audio {
  width: 100%;
  filter: grayscale(10%);
}

/* AÇÕES */
.preview-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* BOTÕES */
.icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.04);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 
    background 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

/* HOVER GERAL */
.icon-btn:hover {
  background: rgba(0, 0, 0, 0.12);
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* ENVIAR */
.icon-btn.send {
  background: rgba(37, 211, 102, 0.12);
}

.icon-btn.send:hover {
  background: rgba(37, 211, 102, 0.28);
}

/* CANCELAR */
.icon-btn.cancel {
  background: rgba(229, 57, 53, 0.12);
}

.icon-btn.cancel:hover {
  background: rgba(229, 57, 53, 0.28);
}

      `}</style>
    </div>
  );
};

export default AudioRecorder;
